export const getCurrentLocation = state => {
    const { location } = state.location;
    const { slug } = location;
    return slug;
};
